import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES } from '../constants/app.constants';

export const FORCE_CHANGE_PASSWORD_ROUTE = 'force-change-password';

export const MustChangePasswordGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isUserLoggedIn()) {
    return true; // Other guards (or PublicGuard) handle anonymous flow.
  }

  const token = auth.getDecodedToken();
  const onForceChangeRoute = state.url.includes(FORCE_CHANGE_PASSWORD_ROUTE);

  if (token.mustChangePassword && !onForceChangeRoute) {
    return router.createUrlTree(['/' + FORCE_CHANGE_PASSWORD_ROUTE]);
  }
  if (!token.mustChangePassword && onForceChangeRoute) {
    return router.createUrlTree([auth.homeRoute()]);
  }
  return true;
};

export const FORCE_CHANGE_PUBLIC_ROUTES = [
  PUBLIC_ROUTES.login,
  PUBLIC_ROUTES.signIn,
  PUBLIC_ROUTES.forgotPassword,
  PUBLIC_ROUTES.resetPassword,
];
